module.exports = __webpack_public_path__ + "static/media/logo.d0e2d96d.svg";